import { useAccessSessionApi } from '@client-app-sdk/hooks';
import useListQuery from '@client-app-sdk/utils/use-list-query';
import { AccessSessionsApiListAccessSessionsRequest } from '@client-app-sdk/api/v1';
import { GET_ACCESS_SESSION_QUERY_KEY, LIST_ACCESS_SESSIONS_QUERY_KEY } from './query-keys';
import { QueryFunctionContext, useQueryClient } from '@tanstack/react-query';
import { API_LIMIT } from '@client-app-sdk/utils/constants';

export default function useListAccessSessions({
  limit,
  skip,
  refetch,
  ...props
}: AccessSessionsApiListAccessSessionsRequest & { refetch?: number }) {
  const api = useAccessSessionApi();
  const queryClient = useQueryClient();

  const fetchMethod = async ({ pageParam = 0 }: QueryFunctionContext) => {
    const result = await api.listAccessSessions({
      ...props,
      limit: limit ?? API_LIMIT,
      skip: pageParam,
    });

    result.data.forEach((session) => {
      queryClient.setQueryData([GET_ACCESS_SESSION_QUERY_KEY, session.id], session);
    });

    return result;
  };

  return useListQuery({
    fetchMethod,
    queryKey: [LIST_ACCESS_SESSIONS_QUERY_KEY, props],
    initialOffset: skip,
    refetch,
  });
}
